import React, { useCallback, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { withIntl } from '@jutro/locale';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './DocumentsUploadComponent.metadata.json5';
import styles from './DocumentsUploadComponent.modules.scss';

function DocumentsComponent({ docTypeList, onDocumentUpload }) {
    const [fileData, setFileData] = useState({});
    const [docType, setDocType] = useState('');
    const [docDesc, setDocDesc] = useState('');

    const onBrowseData = useCallback((item) => {
        setFileData(item);
    }, [setFileData]);

    const handleDocumentTypeChange = useCallback((item) => {
        setDocType(item);
    }, []);

    const documentDescription = useCallback((item) => {
        setDocDesc(item);
    }, []);

    const handleDocumentUpload = useCallback(
        () => {
            onDocumentUpload(fileData, docType, docDesc);
            setDocType('');
            setDocDesc('');
            setFileData('');
        },
        [onDocumentUpload, fileData, docType, docDesc]
    );

    const overrides = {
        documentName: {
            value: _.get(fileData, 'name', ''),
            disabled: _.isEmpty(_.get(fileData, 'name', ''))
        },
        browseButton: {
            accept: _.get(appConfig, 'tdic.supportedFileFormats.extensions', '')
        },
        uploadButton: {
            disabled: _.isEmpty(docType) || _.isEmpty(_.get(fileData, 'name', ''))
        },
        documentType: {
            value: docType,
            availableValues: docTypeList,
            onValueChange: handleDocumentTypeChange
        },
        docDescription: {
            value: docDesc,
            onValueChange: documentDescription
        },
    };

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(metadata.componentContent, DocumentsComponent,
                id, path, overrides);
        },
        [overrides]
    );

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onBrowseButton: onBrowseData,
            onDocumentUpload: handleDocumentUpload
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            classNameMap={resolvers.resolveClassNameMap}
            callbackMap={resolvers.resolveCallbackMap}
            resolveValue={readValue}
        />
    );
}

DocumentsComponent.propTypes = {
    docTypeList: PropTypes.shape([]),
    onDocumentUpload: PropTypes.func.isRequired
};
DocumentsComponent.defaultProps = {
    docTypeList: []
};

export default withIntl(DocumentsComponent);
